import { jsx as _jsx } from "react/jsx-runtime";
import { DependencyInjectionContext } from "./DependencyInjectionContext";
export const DependencyInjectionProvider = props => {
    const { container, children } = props;
    return _jsx(DependencyInjectionContext.Provider, { value: { container }, children: children });
};
